const STORAGE_KEY = "csrp_admin_service_requests_list_state";

/** Query param on SR detail back navigation (matches menu route id). */
export const ADMIN_SERVICE_REQUESTS_FROM_LIST = "admin-service-requests";

export function saveAdminServiceRequestListState(state) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore quota / private mode */
  }
}

export function readAdminServiceRequestListState() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAdminServiceRequestListState() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** True when URL carries dashboard chart drill-down params (must not restore stale list snapshot). */
export function hasAdminServiceRequestListDrilldownUrl(search) {
  const p = new URLSearchParams(search || "");
  return Boolean(
    p.get("fromDate") ||
      p.get("toDate") ||
      p.get("marketCode") ||
      p.get("zoneName") ||
      p.get("zone") ||
      p.get("bv") ||
      p.get("bvName") ||
      p.get("category") ||
      p.get("status") ||
      p.get("settlementType") ||
      p.get("srNo") ||
      p.get("queryRaised") ||
      p.get("repeatComplaint") ||
      p.get("repeatScopeFrom") ||
      p.get("repeatComplaintsScopeFromDate")
  );
}

export function readAdminServiceRequestListRestoreSnapshot() {
  const saved = readAdminServiceRequestListState();
  if (!saved?.pendingRestore) return null;
  return saved;
}

export function markAdminServiceRequestListPendingRestore() {
  const saved = readAdminServiceRequestListState();
  if (!saved) return;
  saveAdminServiceRequestListState({ ...saved, pendingRestore: true });
}

export function markAdminServiceRequestListRestored() {
  const saved = readAdminServiceRequestListState();
  if (!saved) return;
  saveAdminServiceRequestListState({ ...saved, pendingRestore: false });
}
